module.exports = __webpack_public_path__ + "static/media/logo.410bdbfc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/knowhow/logo.jpg
// module id = 387
// module chunks = 1